import React, { useState, useEffect } from "react"
import useOutsideClick from "../../helpers/useOutsideClick"
import {
  DropdownContainer,
  DropdownOption,
  DropdownControl,
  DropdownControlArrow,
  DropdownSelectMenu,
  ChevronDownIcon,
  ChevronUpIcon,
  DropdownItemCheck,
  DropdownLabel
} from "./course-filter-dropdown.style"

const CourseFilterDropdown = ({ options, handleChange, activeValue }) => {
  const [selectedOption, setSelectedOption] = useState(
    options.find((option) => option.value === activeValue) ?? options[0]
  )

  const [shouldOpen, setShouldOpen] = useState(false)
  const [coursesDropdownLabel, setCoursesDropdownLabel] = useState("Sort By:")
  const toggle = () => setShouldOpen(!shouldOpen)
  const dropdownRef = useOutsideClick(() => setShouldOpen(false))

  const getCoursesDropdownLabel = () => {
    return coursesDropdownLabel
  }

  useEffect(() => {
    if (selectedOption.value === "most_popular" && coursesDropdownLabel === "Sort By:") {
      setCoursesDropdownLabel("Sort By:")
    } else if (selectedOption.value === "most_popular") {
      setCoursesDropdownLabel("Most Popular")
    } else if (selectedOption.value === "most_recent") {
      setCoursesDropdownLabel("Most Recent")
    } else {
      setCoursesDropdownLabel("Sort By:")
    }
    // eslint-disable-next-line
  }, [selectedOption])


  const changeHandler = (option) => {
    setSelectedOption(option)
    handleChange(option)
  }

  useEffect(() => {
    setSelectedOption(
      options.find((option) => option.value === activeValue) ?? options[0]
    )
  }, [options, activeValue])

  return (
    <DropdownContainer
      tabIndex="0"
      onClick={toggle}
      ref={dropdownRef}
      onKeyPress={(e) => {
        if (e.key === "Enter") toggle()
      }}
    >
      <DropdownControl className={shouldOpen ? "active" : ""}>
        <DropdownLabel>{getCoursesDropdownLabel()}</DropdownLabel>
        <DropdownControlArrow
          onClick={(e) => {
            e.stopPropagation()
            toggle()
          }}
        >
          {shouldOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </DropdownControlArrow>
      </DropdownControl>
      {options.length && shouldOpen && (
        <DropdownSelectMenu>
          {options.map((option) => (
            <DropdownOption
              tabIndex="0"
              key={option.value}
              active={option.value === selectedOption.value}
              onClick={() => changeHandler(option)}
              onKeyPress={(e) => {
                if (e.key === "Enter") changeHandler(option)
              }}
            >
              <span>{option.label}</span>
              <DropdownItemCheck
                active={option.value === selectedOption.value}
              />
            </DropdownOption>
          ))}
        </DropdownSelectMenu>
      )}
    </DropdownContainer>
  )
}

export default CourseFilterDropdown
